import {Pipe, PipeTransform} from '@angular/core';
import {DayOfWeek} from '../classes/enums/DayOfWeek';

/**
 * This pipe transforms day of week.
 */
@Pipe({
  name: 'dayOfWeekParse',
})
export class DayOfWeekParsePipe implements PipeTransform {

  /**
   * Transforms day of week to a shortened string.
   * @example
   * // returns 'Mon'
   * transform(DayOfWeek.MONDAY)
   * @param value day of week to transform.
   */
  transform(value: DayOfWeek) {
    if (!value) {
      return;
    }
    return value.charAt(0) + value.substring(1, 3).toLowerCase();
  }
}

export function dayOfWeekParse(value: DayOfWeek): string {
  return new DayOfWeekParsePipe().transform(value);
}
